









































































































































































































































































































































































































































import Vue from 'vue'
import valueAt from 'lodash/get'
import VInput from './VInput.vue'

export default Vue.extend({
  components: {
    VInput
  },

  props: {
    title: String,
    isLoading: {
      type: Boolean,
      default: false
    },
    filterData: {
      type: Array,
      default: () => []
    },

    columns: {
      type: Array,
      default: () => []
    },

    items: {
      type: Array,
      default: () => []
    },

    addButtonText: {
      type: String,
      default: 'Ajouter'
    },

    noDataText: {
      type: String,
      default: 'Aucune donnée disponible'
    },

    loading: Boolean,
    loadingText: {
      type: String,
      default: 'Chargement des données'
    },

    height: [String, Number],

    sortBy: String,
    sortDesc: Boolean,
    flat: Boolean,
    hideAddAction: Boolean,
    hideSearchInput: Boolean,
    hideTableHeader: Boolean,

    rowClass: {
      type: Function,
      default: () => ''
    },

    expandable: Boolean,
    paginated: Boolean,
    itemPerPage: Number
  },

  data() {
    return {
      dateDebut: '',
      dateFin: '',
      search: '',
      filtre: 0,
      sort: {
        field: '',
        desc: false
      },
      perPage: this.itemPerPage || 10,
      page: 1,
      rowsDetailsExpanded: {},
      models: new Object() as any
    }
  },

  computed: {
    nbFilter(): number {
      let nbFilter = 0
      console.log(this.models)
      if (this.dateDebut != '') nbFilter += 1

      if (this.dateFin != '') nbFilter += 1

      Object.keys(this.models).forEach(val => {
        if (this.models[val] != '') nbFilter += 1
      })

      return nbFilter
    },
    getDateDebut(): any {
      return this.pickDate(this.dateDebut)
    },
    getDateFin(): any {
      return this.pickDate(this.dateFin)
    },
    total(): any {
      return this.items.length
    },

    pages(): number {
      return Math.ceil(this.total / this.perPage)
    },

    bodyStyle(this: any) {
      const style: Record<string, any> = {}

      if (this.height) {
        style.height = `${this.height}px`
      }

      return style
    },

    tableHeaderStyle(this: any) {
      const style: Record<string, any> = {}

      if (this.height) {
        style.position = 'sticky'
        style.top = 0
      }

      return style
    },

    formattedColumns(this: any) {
      return this.columns.map((col: any) => ({
        sortable: true,
        searchable: false,
        align: 'left',
        sortFn: () => '',
        ...col
      }))
    },

    filteredItems(this: any) {
      if (!this.search || this.searchableFields.length === 0) {
        return this.items
      }

      const searchReg = new RegExp(this.search, 'gi')

      return this.items.filter((item: any) =>
        this.searchableFields.some((field: string) =>
          searchReg.test(valueAt(item, field))
        )
      )
    },

    sortedItems(this: any) {
      if (!this.sort.field) {
        return this.filteredItems
      }

      return this.filteredItems.concat().sort((itemA: any, itemB: any) => {
        const valueA = valueAt(itemA, this.sort.field)
        const valueB = valueAt(itemB, this.sort.field)

        if (valueA < valueB) {
          return this.sort.desc ? 1 : -1
        } else if (valueA > valueB) {
          return this.sort.desc ? -1 : 1
        } else {
          return 0
        }
      })
    },

    visibleItems(this: any) {
      if (!this.paginated) {
        return this.sortedItems
      }

      const start = (this.page - 1) * this.perPage
      return this.sortedItems.slice(start, start + this.perPage)
    },

    searchableFields(this: any) {
      return this.columns
        .filter((col: any) => col.searchable)
        .map((col: any) => col.field)
    }
  },

  watch: {
    sortBy(this: any, field) {
      this.sort.field = field
    },

    sortDesc(this: any, desc) {
      this.sort.desc = desc
    }
  },

  created(this: any) {
    this.sort.field = this.sortBy
    this.sort.desc = !!this.sortDesc

    if (!this.sort.field) {
      this.sort.field = this.formattedColumns.find((col: any) => col.sortable)
    }

    for (const item of this.filterData) {
      this.models[item.model] = ''
    }

    console.log('aaaaaaaaaa', this.models)
  },

  methods: {
    pickDate(data: any) {
      console.log(data)

      if (data == '') return
      const changeDate = new Date(data)
      console.log(changeDate.toLocaleString('default').split(','))

      return changeDate.toLocaleString('default').split(',')[0]
    },

    formatDate(data: any) {
      if (data == '') return ''
      const changeDate = new Date(data)
      const newDate = changeDate
        .toLocaleString('default')
        .split(',')[0]
        .split('/')
        .reverse()
        .join('-')
      console.log(newDate)

      return newDate
    },

    apply() {
      this.$emit('change', {
        dateDebut: this.formatDate(this.dateDebut),
        dateFin: this.formatDate(this.dateFin),
        search: this.search,
        ...this.models
      })
      this.filtre = 0
    },

    annuler() {
      this.showFilter(0)
      this.dateDebut = ''
      this.dateFin = ''
      if (this.search.length == 0) return
      Object.keys(this.models).forEach(val => {
        console.log('ddd', this.models[val])
        this.models[val] = ''
        console.log('aaaaaaaaaaaaaaaa', this.models[val])
      })
      this.$emit('change', {
        dateDebut: this.dateDebut,
        dateFin: this.dateFin,
        search: this.search,
        ...this.models
      })
    },

    getItemField(item: any, field: string) {
      return valueAt(item, field)
    },
    showFilter(i: any) {
      this.filtre = i
    },

    onAddClicked() {
      this.$emit('click:add')
    },

    onPrevClicked() {
      if (this.page > 1) {
        this.page--
      }
    },

    onNextClicked() {
      if (this.page < this.pages) {
        this.page++
      }
    },

    isRowExpanded(this: any, index: number) {
      return !!this.rowsDetailsExpanded[index]
    },

    toggleRowDetails(this: any, index: number) {
      this.$set(this.rowsDetailsExpanded, index, !this.isRowExpanded(index))
    },

    onColumnClicked(this: any, column: any) {
      if (!column.sortable) {
        return
      }

      this.sort.field = column.field
      this.sort.desc = !this.sort.desc

      this.$emit('update:sort-by', this.sort.field)
      this.$emit('update:sort-desc', this.sort.desc)
    }
  }
})
